import { MenuApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const labelSetApi = {
  index: wrap(MenuApi, MenuApi.prototype.indexLabelSetList),
  show: wrap(MenuApi, MenuApi.prototype.showLabelSet),
  create: wrap(MenuApi, MenuApi.prototype.createLabelSet),
  update: wrap(MenuApi, MenuApi.prototype.updateLabelSet),
};
